import {SystemTransactionTypeInterface} from "../types/Responses/SystemResponse";

export const resolveTransactionTypeId = (
    types: SystemTransactionTypeInterface[] | undefined,
    name: string,
    fallback: number
): number => {
    const normalized = name.toLowerCase();
    const match = types?.find((type) => type.name.toLowerCase() === normalized);

    return match?.id ?? fallback;
};
